import { Lightning } from '@lightningjs/sdk'

export default class Splash extends Lightning.Component {
  static _template() {
    return {
      Background: {
        rect: true,
        color: 0xff4a98d7,
        w: 1920,
        h: 1080,
      },
      Text: {
        mount: 1,
        x: 1900,
        y: 1060,
        text: {
          text: 'Loading...',
          fontFace: 'Regular',
          fontSize: 20,
          textColor: 0xffffffff,
        },
      },
    }
  }
}
